import { Typography } from 'material-ui'
import * as React from 'react'
import { SFC } from 'react'
import { BlueGreenBar } from './BlueGreenBar'

export const SpreadHeading: SFC<{ title: string }> = ({title}) => (
    <div>
        <BlueGreenBar/>
        <Typography type='display1' style={{margin: '20px 0'}}>
            {title}
        </Typography>
    </div>
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/SpreadHeading.tsx